import { Button, Icon, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { ForaLogoIcon } from '@assets/icons';
import StepContentsContainer from './step-contents-container.component';

const OnboardingComplete = ({ firstName }) => {
  const navigate = useNavigate();
  return (
    <StepContentsContainer
      gap={12}
      justify='space-between'
      pb={24}
      my='auto'
    >
      <Icon
        as={ForaLogoIcon}
        color='brandPrimary.primary'
        boxSize={24}
      />
      <Text
        variant='display-sm'
        align='center'
      >
        You&apos;re all set, {firstName}!
      </Text>
      <Button onClick={() => navigate('/')}>Jump into your workspace</Button>
    </StepContentsContainer>
  );
};

export default OnboardingComplete;
